import { render, staticRenderFns } from "./AdjustingChargesCredits.vue?vue&type=template&id=195ef0d2&scoped=true"
import script from "./AdjustingChargesCredits.vue?vue&type=script&lang=js"
export * from "./AdjustingChargesCredits.vue?vue&type=script&lang=js"
import style0 from "./AdjustingChargesCredits.vue?vue&type=style&index=0&id=195ef0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195ef0d2",
  null
  
)

export default component.exports